import React from 'react';
import { Card } from './ui/card';
import BirdAvatarOption from './BirdAvatarPreview';

// STEP 1: Top 20 Most Universally Appealing (from original 40)
export const TOP_20_UNIVERSAL = [
  { id: 1, color: '#FF6B9D', accessory: 'none', name: 'Bubblegum', description: 'Sweet & Classic' },
  { id: 2, color: '#4ECDC4', accessory: 'tiny-glasses', name: 'Smarty', description: 'Nerdy & Proud' },
  { id: 3, color: '#FFD93D', accessory: 'tiny-bow', name: 'Sunny', description: 'Bright & Cheerful' },
  { id: 5, color: '#FF8ED4', accessory: 'heart', name: 'Sweetheart', description: 'Full of Love' },
  { id: 6, color: '#C7A4FF', accessory: 'tiny-crown', name: 'Royal', description: 'Fancy & Fabulous' },
  { id: 8, color: '#6FEDD6', accessory: 'star', name: 'Starry', description: 'Dreamy & Magical' },
  { id: 9, color: '#FFB347', accessory: 'cool-shades', name: 'Chill', description: 'Too Cool for School' },
  { id: 10, color: '#B19CD9', accessory: 'party-hat', name: 'Party', description: 'Always Celebrating' },
  { id: 17, color: '#FFD700', accessory: 'sparkle', name: 'Glitter', description: 'Sparkly & Shiny' },
  { id: 19, color: '#F7B2BD', accessory: 'cherry', name: 'Cherry', description: 'Sweet & Juicy' },
  { id: 21, color: '#FFB3E6', accessory: 'bunny-ears', name: 'Cottontail', description: 'Hoppy & Bouncy' },
  { id: 22, color: '#B4E7CE', accessory: 'donut', name: 'Sprinkles', description: 'Sweet as Sugar' },
  { id: 23, color: '#FFA5BA', accessory: 'cat-ears', name: 'Whiskers', description: 'Purr-fectly Cute' },
  { id: 24, color: '#A0E7E5', accessory: 'ice-cream', name: 'Frosty', description: 'Cool & Sweet' },
  { id: 25, color: '#FFAEBC', accessory: 'rainbow', name: 'Sunny Day', description: 'Colorful & Happy' },
  { id: 26, color: '#B4F8C8', accessory: 'bear-ears', name: 'Teddy', description: 'Cuddly & Warm' },
  { id: 29, color: '#FFCFD2', accessory: 'balloon', name: 'Float', description: 'Light as Air' },
  { id: 32, color: '#FFED4E', accessory: 'sunburst', name: 'Sunshine', description: 'Bright & Warm' },
  { id: 33, color: '#FFD1DC', accessory: 'lollipop', name: 'Candy', description: 'Super Sweet' },
  { id: 39, color: '#FFDFD3', accessory: 'cookie', name: 'Chips', description: 'Freshly Baked' }
];

// STEP 2: 10 Brand New Options
export const NEW_10 = [
  { id: 41, color: '#FFFFFF', accessory: 'panda', name: 'Bamboo', description: 'Cuddly Panda' },
  { id: 42, color: '#FFB3FF', accessory: 'unicorn', name: 'Magic', description: 'Sparkly Unicorn' },
  { id: 43, color: '#FF6B6B', accessory: 'strawberry', name: 'Berry', description: 'Sweet Berry' },
  { id: 44, color: '#8B7355', accessory: 'coffee', name: 'Mocha', description: 'Cozy Café' },
  { id: 45, color: '#90EE90', accessory: 'frog-hat', name: 'Hoppy', description: 'Froggy Friend' },
  { id: 46, color: '#E0E0E0', accessory: 'astronaut', name: 'Cosmo', description: 'Space Explorer' },
  { id: 47, color: '#9370DB', accessory: 'witch-hat', name: 'Spooky', description: 'Magical Witch' },
  { id: 48, color: '#FFB6C1', accessory: 'headphones', name: 'Beats', description: 'Music Lover' },
  { id: 49, color: '#FFE5B4', accessory: 'sushi', name: 'Wasabi', description: 'Sushi Roll' },
  { id: 50, color: '#C1E1C1', accessory: 'avocado', name: 'Guac', description: 'Avo-cutie' }
];

// STEP 3: THE 10 ABSOLUTE CUTEST (My Expert Selection)
// Based on: Maximum adorableness, universal appeal, variety, and "aww" factor
export const FINAL_10_CUTEST = [
  { id: 21, color: '#FFB3E6', accessory: 'bunny-ears', name: 'Cottontail', description: 'Hoppy & Bouncy', reason: '🐰 Bunny ears are universally adored!' },
  { id: 42, color: '#FFB3FF', accessory: 'unicorn', name: 'Magic', description: 'Sparkly Unicorn', reason: '🦄 Magical & whimsical!' },
  { id: 22, color: '#B4E7CE', accessory: 'donut', name: 'Sprinkles', description: 'Sweet as Sugar', reason: '🍩 Donut with sprinkles = instant cute!' },
  { id: 23, color: '#FFA5BA', accessory: 'cat-ears', name: 'Whiskers', description: 'Purr-fectly Cute', reason: '🐱 Cat ears are always a hit!' },
  { id: 24, color: '#A0E7E5', accessory: 'ice-cream', name: 'Frosty', description: 'Cool & Sweet', reason: '🍦 Triple scoop cuteness!' },
  { id: 26, color: '#B4F8C8', accessory: 'bear-ears', name: 'Teddy', description: 'Cuddly & Warm', reason: '🧸 Bear hugs for everyone!' },
  { id: 43, color: '#FF6B6B', accessory: 'strawberry', name: 'Berry', description: 'Sweet Berry', reason: '🍓 Strawberry is berry cute!' },
  { id: 41, color: '#FFFFFF', accessory: 'panda', name: 'Bamboo', description: 'Cuddly Panda', reason: '🐼 Pandas = peak cuteness!' },
  { id: 25, color: '#FFAEBC', accessory: 'rainbow', name: 'Sunny Day', description: 'Colorful & Happy', reason: '🌈 Rainbow brings joy!' },
  { id: 33, color: '#FFD1DC', accessory: 'lollipop', name: 'Candy', description: 'Super Sweet', reason: '🍭 Sweet as candy!' }
];

const FinalAvatarSelection = () => {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="container mx-auto max-w-6xl">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-heading font-bold mb-4">
            <span className="text-gradient-primary">Final Avatar Selection</span>
          </h1>
          <p className="text-xl text-muted-foreground">
            From 50 options to the 10 cutest avatars! 🎨
          </p>
        </div>

        {/* THE FINAL 10 */}
        <div className="mb-16">
          <div className="text-center mb-8">
            <h2 className="text-4xl font-heading font-bold mb-2">
              🏆 THE 10 CUTEST AVATARS 🏆
            </h2>
            <p className="text-lg text-muted-foreground">
              Selected for maximum adorableness and universal appeal!
            </p>
          </div>
          
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-6 mb-8">
            {FINAL_10_CUTEST.map((avatar, index) => (
              <Card key={avatar.id} className="p-4 bg-gradient-to-br from-primary/5 to-primary/10 border-primary/30 shadow-lg">
                <div className="text-center mb-2">
                  <div className="inline-block px-3 py-1 rounded-full bg-primary text-primary-foreground font-bold text-sm mb-2">
                    #{index + 1}
                  </div>
                </div>
                <BirdAvatarOption option={avatar} size={100} />
                <div className="mt-3 text-center">
                  <p className="text-xs text-muted-foreground">{avatar.reason}</p>
                </div>
              </Card>
            ))}
          </div>

          <Card className="p-6 bg-gradient-card">
            <h3 className="font-semibold text-lg mb-3 text-center">Why These 10?</h3>
            <div className="grid md:grid-cols-2 gap-4 text-sm">
              <div>
                <p className="font-semibold text-primary mb-2">✨ Maximum Cuteness:</p>
                <ul className="space-y-1 text-muted-foreground">
                  <li>• Universally loved animals (bunny, cat, bear, panda)</li>
                  <li>• Sweet treats (donut, ice cream, strawberry, candy)</li>
                  <li>• Magical elements (unicorn, rainbow)</li>
                </ul>
              </div>
              <div>
                <p className="font-semibold text-primary mb-2">🎯 Universal Appeal:</p>
                <ul className="space-y-1 text-muted-foreground">
                  <li>• Gender-neutral designs</li>
                  <li>• Appeals to all ages (kids to adults)</li>
                  <li>• Culturally inclusive</li>
                  <li>• Bright, cheerful colors</li>
                </ul>
              </div>
            </div>
          </Card>
        </div>

        {/* Show the selection process */}
        <div className="space-y-12">
          <div>
            <h3 className="text-2xl font-heading font-bold mb-4">Step 1: Top 20 Universal (from 40)</h3>
            <div className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-10 gap-3">
              {TOP_20_UNIVERSAL.map(avatar => (
                <Card key={avatar.id} className="p-2">
                  <BirdAvatarOption option={avatar} size={60} />
                </Card>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-2xl font-heading font-bold mb-4">Step 2: 10 Brand New Options</h3>
            <div className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-10 gap-3">
              {NEW_10.map(avatar => (
                <Card key={avatar.id} className="p-2">
                  <BirdAvatarOption option={avatar} size={60} />
                </Card>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinalAvatarSelection;
